import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-px-3 border-top p-pb-3" }
const _hoisted_2 = { class: "p-mb-3 p-pt-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-pb-2" }, [
  /*#__PURE__*/_createTextVNode(" เอกสารการจัดส่ง (Tracking / ใบเสร็จการจัดส่ง)"),
  /*#__PURE__*/_createElementVNode("span", { class: "p-error" }, "*")
], -1)
const _hoisted_4 = { class: "p-mb-3" }
const _hoisted_5 = { class: "p-mb-3" }
const _hoisted_6 = { class: "p-mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFilePanel = _resolveComponent("UploadFilePanel")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputTextCustom = _resolveComponent("InputTextCustom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createVNode(_component_UploadFilePanel, {
            dataList: _ctx.form.Attachment,
            modelValue: _ctx.form.Attachment,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Attachment) = $event)),
            format: "all",
            name: "fileUpload",
            text: "ทดสอบ",
            maxFileLength: 5,
            onOnFileChange: _ctx.onImageChange,
            isMultiple: "",
            typeFile: "image/jpeg, image/png, application/pdf"
          }, null, 8, ["dataList", "modelValue", "onOnFileChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_InputSelect, {
          title: "ระบบการขนส่ง",
          text: "ระบบการขนส่ง",
          name: "shippingId",
          valueField: "id",
          textField: "name",
          placeholder: "กรุณาเลือก",
          options: _ctx.shippingList,
          onOnDataChange: _ctx.onShippingChange,
          "model-value": _ctx.form.shippingId,
          isRequired: "",
          isDisplay: _ctx.isDisableShipping,
          ref: "shippingId"
        }, null, 8, ["options", "onOnDataChange", "model-value", "isDisplay"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_InputTextCustom, {
          "model-value": _ctx.form.trackingNo,
          textFloat: "เลขติดตามพัสดุ",
          placeholder: "เลขติดตามพัสดุ",
          type: "text",
          name: "trackingNo",
          isRequired: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.trackingNo = $event)),
          isDisplay: _ctx.isDisableShipping,
          class: "f-regular"
        }, null, 8, ["model-value", "isDisplay"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_InputTextCustom, {
          "model-value": _ctx.form.shippingAmount,
          textFloat: "ค่าจัดส่ง",
          placeholder: "ค่าจัดส่ง",
          type: "number",
          name: "shippingAmount",
          isRequired: "",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.shippingAmount = $event)),
          isDisplay: _ctx.isDisableShipping,
          class: "f-regular"
        }, null, 8, ["model-value", "isDisplay"])
      ])
    ])
  ]))
}